let apiConfig = {
	api: {
        APIURL: 'https://api.fliktrax.com/',
		APIUSERNAME: 'fliktrax',
		APIPASSWORD: 'rocknroll'
	}
};

export default apiConfig
